import { Form, FormInstance, Row } from "antd";
import { FirstStep } from "./FirstStep";
import { Loader } from "../../../components/Loader";
import { useFetchData } from "../hooks/useFetchData";
import { useCallback, useMemo, useState } from "react";
import { SecondStep } from "./SecondStep";
import { ThirdStep } from "./ThirdStep";
import { SuccessStep } from "./SuccessStep";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { Error } from "./Error";

type StepsContentProps = {
  step: number;
  accountId: string | undefined;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};

export const StepsContent = ({
  step,
  accountId,
  setStep,
}: StepsContentProps) => {
  const [request, setRequest] = useState<any>({});

  const [error, setError] = useState<string | null>(null);

  const [form]: FormInstance[] = Form.useForm();

  const navigate: NavigateFunction = useNavigate();

  const { data, isLoading } = useFetchData(accountId, setRequest, setError);

  const initialValues = useMemo(
    () => ({
      amountOption: 1,
    }),
    [],
  );

  const onBackButtonClicked = useCallback(() => navigate(-1), [navigate]);

  return (
    <Row className="steps justify-center overflow-auto">
      {!isLoading ? (
        !error ? (
          <Row className="d-block w-100">
            <Form
              requiredMark={false}
              form={form}
              layout="vertical"
              className="w-100 d-flex justify-center"
              initialValues={initialValues}
            >
              {step === 1 && (
                <FirstStep
                  data={data}
                  form={form}
                  setStep={setStep}
                  setRequest={setRequest}
                />
              )}
              {step === 2 && (
                <SecondStep
                  form={form}
                  request={request}
                  setStep={setStep}
                  setRequest={setRequest}
                />
              )}
              {step === 3 && <ThirdStep request={request} setStep={setStep} />}
              {step === 4 && <SuccessStep request={request} />}
            </Form>
          </Row>
        ) : (
          <Error
            contractId={accountId || ""}
            error={error}
            onBackButtonClicked={onBackButtonClicked}
          />
        )
      ) : (
        <Loader fontSize="128px" />
      )}
    </Row>
  );
};
